import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  transferLoading: false,
  transactionLoading: false,
  transferInfo: null,
  accountBalance: null,
  exchangeRates: null,
  transactionList: null,
  beneficiaryList: null,
  beneficiaryData: null,
  beneficiaryLoading: null,
  beneficiaryDeleteLoading: null,
  activateLoading: null,
  fee_withdrawal: null,
};

const tradingSlice = createSlice({
  name: "transfer",
  initialState,
  reducers: {
    setTransferLoading: (state, action) => {
      state.transferLoading = action.payload;
    },
    setTransactionLoading: (state, action) => {
      state.transactionLoading = action.payload;
    },
    setTransferInfo: (state, action) => {
      state.transferInfo = action.payload;
    },
    setAccountBalance: (state, action) => {
      state.accountBalance = action.payload;
    },
    setExchangeRates: (state, action) => {
      state.exchangeRates = action.payload;
    },
    setTransactionList: (state, action) => {
      state.transactionList = action.payload;
    },
    setBeneficiaryList: (state, action) => {
      state.beneficiaryList = action.payload;
    },
    setBeneficiaryData: (state, action) => {
      state.beneficiaryData = action.payload;
    },
    setBeneficiaryLoading: (state, action) => {
      state.beneficiaryLoading = action.payload;
    },
    setBeneficiaryDeleteLoading: (state, action) => {
      state.beneficiaryDeleteLoading = action.payload;
    },
    setActivateLoading: (state, action) => {
      state.activateLoading = action.payload;
    },
    setFeeWithdrawal: (state, action) => {
      state.fee_withdrawal = action.payload;
    },
  },
});

export const {
  setTransferLoading,
  setTransactionLoading,
  setTransferInfo,
  setAccountBalance,
  setExchangeRates,
  setTransactionList,
  setBeneficiaryList,
  setBeneficiaryData,
  setBeneficiaryLoading,
  setBeneficiaryDeleteLoading,
  setActivateLoading,
  setFeeWithdrawal,
} = tradingSlice.actions;
export default tradingSlice.reducer;
